module.exports = __webpack_public_path__ + "static/fccMafia-82802bb29600b31393cd58b42ea21454.jpg";